import clsx from 'clsx';

function MenuDropdownButton({
    title,
    showDropdown = false,
    dropdownOpen,
    isFullWidth,
    onClick,
    onMouseEnter,
    onMouseLeave,
}: Readonly<{
    title: string;
    isFullWidth?: boolean;
    showDropdown?: boolean;
    dropdownOpen: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
    onMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
}>) {
    return (
        <div
            className={clsx(
                'flex h-full flex-row items-center justify-between gap-[4px]',
                {
                    'w-full': isFullWidth,
                },
            )}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="flex flex-row items-center justify-center gap-[8px]">
                {title}
            </div>
            {showDropdown && (
                <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={clsx('transition-transform duration-200', {
                        'rotate-180': dropdownOpen,
                    })}
                >
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            )}
        </div>
    );
}

export default MenuDropdownButton;
